<template>
  <div>
    <h2 class="text-h3 mb-3">Source Articles</h2>
    <NewsTab :market="slug" :categories-articles="categoriesArticles" />

    <h2 class="text-h3 mb-3 mt-6">Price Analysis</h2>
    <PriceAnalysisTab
      :name="COBALT.name"
      :slug="COBALT.slug"
      :service-base-path="COBALT.serviceBasePath"
      :icon="COBALT.icon"
    />
  </div>
</template>

<script lang="ts" setup>
import { COBALT } from '~/constants/services/constants'
import PriceAnalysisTab from '~/components/market-insights/PriceAnalysisTab.vue'
import NewsTab from '~/components/market-insights/NewsTab.vue'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

/*-------------------------------------
  Props & Refs
-------------------------------------*/
defineProps<{
  slug: string
  categoriesArticles?: string[]
}>()
</script>
